import type { PortalBranding } from './branding'
import { useLayoutEffect } from 'react'

const ensureLink = (rel: string): HTMLLinkElement => {
  let link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`)
  if (!link) {
    link = document.createElement('link')
    link.rel = rel
    document.head.appendChild(link)
  }
  return link
}

/**
 * Applies the tenant favicon, touch icon, and document title from branding.
 * Each is left untouched when the tenant hasn't set it, so the portal keeps its
 * defaults (e.g. the browser-default favicon).
 */
export const useBrandAssets = (branding: PortalBranding | null): void => {
  useLayoutEffect(() => {
    if (!branding) return
    if (branding.faviconUrl) {
      ensureLink('shortcut icon').href = branding.faviconUrl
    }
    if (branding.touchIconUrl) {
      ensureLink('apple-touch-icon-precomposed').href = branding.touchIconUrl
    }
    if (branding.brandName) document.title = branding.brandName
  }, [branding])
}
